const PREVIEW_HOST = /^(?:preview|[0-9a-f]{12}\.preview)\.vetpets\.com\.tr$/

function normalizeHost(value?: string | null): string {
  return value?.trim().toLowerCase().replace(/\.$/, "") || ""
}

function productionUrl(value: string): URL {
  const parsed = new URL(value)
  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
    throw new Error("production origin must use http or https")
  }
  if (parsed.username || parsed.password || parsed.pathname !== "/" || parsed.search || parsed.hash) {
    throw new Error("production origin must be an origin without credentials, path, query, or fragment")
  }
  return parsed
}

export function isVetPetsPreviewHost(value?: string | null): boolean {
  return PREVIEW_HOST.test(normalizeHost(value))
}

export function resolveRequestOrigin({
  requestHost,
  requestOrigin,
  trustedPreviewHost,
  productionOrigin,
  allowDevelopmentOriginFallback = false,
}: {
  requestHost?: string | null
  requestOrigin?: string | null
  trustedPreviewHost?: string | null
  productionOrigin: string
  allowDevelopmentOriginFallback?: boolean
}): string {
  const production = productionUrl(productionOrigin)
  const host = normalizeHost(requestHost)
  if (!host) throw new Error("untrusted request host: missing host")

  if (host === normalizeHost(production.host)) {
    return production.origin
  }

  const preview = normalizeHost(trustedPreviewHost)
  if (preview) {
    if (!isVetPetsPreviewHost(preview) || preview.includes(":")) {
      throw new Error("trusted preview host is invalid")
    }
    if (host === preview) {
      return `https://${preview}`
    }
  }

  if (allowDevelopmentOriginFallback && requestOrigin) {
    const origin = productionUrl(requestOrigin)
    if (origin.origin === production.origin || normalizeHost(origin.host) === host) {
      return origin.origin
    }
  }

  throw new Error(`untrusted request host: ${host}`)
}
